import { render, staticRenderFns } from "./ConnectPhone.vue?vue&type=template&id=20e66187&"
import script from "./ConnectPhone.vue?vue&type=script&lang=js&"
export * from "./ConnectPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports